import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetMatchDetailsResponse } from '../../../../shared/snippets';

function getSnippetMatchDetails(locator: string, snippetId: string, path: string) {
  return get<SnippetMatchDetailsResponse>(`/api/revisions/${nuc(locator)}/snippets/${nuc(snippetId)}/matches/${path}`);
}

export const getSnippetMatchDetailsQueryKey = (locator: string, snippetId: string, path: string): QueryKey => {
  return ['revisions', locator, 'snippets', snippetId, 'matches', path];
};

type Params = {
  locator: string;
  snippetId: string;
  path: string;
};

/**
 * useSnippetMatchDetails is a hook that fetches and returns the snippet match
 * details for a given locator + snippetId + path.
 */
export default function useSnippetMatchDetails({ locator, snippetId, path }: Params, shouldFetch = true) {
  return useQuery<SnippetMatchDetailsResponse>({
    queryKey: getSnippetMatchDetailsQueryKey(locator, snippetId, path),
    queryFn: () => getSnippetMatchDetails(locator, snippetId, path),
    enabled: shouldFetch && !!path,
  });
}
